/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { LocalTime } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class LocalTimeConverter implements BodyConverter<LocalTime> {
  public encode(
    model: LocalTime,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeLocalTime(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): LocalTime {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readLocalTime();
  }
}
